import ActiveTicketsPage from './ActiveTicketsPage'

export default ActiveTicketsPage;